import _Handlebars2 from "../../../../../packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js";
import { View, loc, internal } from "../../../../../packages/@okta/courage-dist/esm/src/CourageForSigninWidget.js";
import "../../../../../packages/@okta/courage-dist/esm/src/courage/framework/Model.js";
import "../../../../../packages/@okta/courage-dist/esm/src/courage/vendor/lib/backbone.js";
import "../../../../../packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js";
import oktaUnderscore from "../../../../../packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js";
import "../../../../../packages/@okta/courage-dist/esm/src/courage/models/Model.js";
import "../../../../../packages/@okta/courage-dist/esm/src/courage/models/BaseModel.js";
import "../../../../../packages/@okta/courage-dist/esm/src/courage/framework/View.js";
import "../../../../../packages/@okta/courage-dist/esm/src/courage/views/Backbone.ListView.js";
import { FORMS } from "../../../ion/RemediationConstants.js";
import { createInvisibleIFrame } from "../../utils/ChallengeViewUtil.js";
const {
  Notification
} = internal.views.components;
const {
  Clipboard
} = internal.util;
var EnrollChannelPollDescriptionView = View.extend({
  initialize: function() {
    let deviceMap = getDeviceMap(this.options.appState);
    if (deviceMap && deviceMap.setupOVUrl && deviceMap.isDesktop) {
      this.ulDom && this.ulDom.remove();
      const IframeView = createInvisibleIFrame("custom-uri-container", deviceMap.setupOVUrl);
      this.ulDom = this.add(IframeView).last();
    }
  },
  template: _Handlebars2.template({
    "1": function(container, depth0, helpers, partials, data) {
      var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return void 0;
      };
      return '<ol class="qrcode-info ov-info"><li>' + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.okta_verify.qrcode.step1"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 48
          },
          "end": {
            "line": 1,
            "column": 114
          }
        }
      })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.okta_verify.qrcode.step2"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 123
          },
          "end": {
            "line": 1,
            "column": 189
          }
        }
      })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "$1": "<span class='strong'>$1</span>",
          "bundle": "login",
          "code": "oie.enroll.okta_verify.qrcode.step3.updated"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 198
          },
          "end": {
            "line": 1,
            "column": 308
          }
        }
      })) + '</li></ol><div class="qrcode-container"><img class="qrcode" src=' + alias3((helper = (helper = lookupProperty(helpers, "href") || (depth0 != null ? lookupProperty(depth0, "href") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
        "name": "href",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 372
          },
          "end": {
            "line": 1,
            "column": 380
          }
        }
      }) : helper)) + ' alt="' + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "mfa.altQrCode"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 386
          },
          "end": {
            "line": 1,
            "column": 431
          }
        }
      })) + '"></img></div>';
    },
    "3": function(container, depth0, helpers, partials, data) {
      var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return void 0;
      };
      return '<ul class="email-info ov-info"><li>' + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "$1": "<span class='strong'>$1</span>",
          "arguments": "email",
          "bundle": "login",
          "code": "oie.enroll.okta_verify.email.info.updated"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 500
          },
          "end": {
            "line": 1,
            "column": 628
          }
        }
      })) != null ? stack1 : "") + '</li><li class="switch-channel-content"></li></ul>';
    },
    "5": function(container, depth0, helpers, partials, data) {
      var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return void 0;
      };
      return '<ul class="sms-info ov-info"><li>' + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "$1": "<span class='strong'>$1</span>",
          "arguments": "phoneNumber",
          "bundle": "login",
          "code": "oie.enroll.okta_verify.sms.info.updated"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 737
          },
          "end": {
            "line": 1,
            "column": 869
          }
        }
      })) != null ? stack1 : "") + '</li><li class="switch-channel-content"></li></ul>';
    },
    "7": function(container, depth0, helpers, partials, data) {
      var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return void 0;
      };
      return '<div class="sameDevice-setup' + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "sameDeviceOVEnrollmentEnabled") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(8, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 982
          },
          "end": {
            "line": 1,
            "column": 1048
          }
        }
      })) != null ? stack1 : "") + '"><p class="explanation" data-se="subheader">' + ((stack1 = lookupProperty(helpers, "if").call(alias1, (stack1 = depth0 != null ? lookupProperty(depth0, "deviceMap") : depth0) != null ? lookupProperty(stack1, "isDesktop") : stack1, {
        "name": "if",
        "hash": {},
        "fn": container.program(10, data, 0),
        "inverse": container.program(17, data, 0),
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 1093
          },
          "end": {
            "line": 1,
            "column": 1866
          }
        }
      })) != null ? stack1 : "") + '</p><ol class="ov-info">' + ((stack1 = lookupProperty(helpers, "unless").call(alias1, depth0 != null ? lookupProperty(depth0, "sameDeviceOVEnrollmentEnabled") : depth0, {
        "name": "unless",
        "hash": {},
        "fn": container.program(19, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 1890
          },
          "end": {
            "line": 1,
            "column": 2304
          }
        }
      })) != null ? stack1 : "") + '<li><a href="' + alias2(container.lambda((stack1 = depth0 != null ? lookupProperty(depth0, "deviceMap") : depth0) != null ? lookupProperty(stack1, "setupOVUrl") : stack1, depth0)) + '" class="button button-primary setup-button">' + alias2((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.okta_verify.setup.title"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 2386
          },
          "end": {
            "line": 1,
            "column": 2451
          }
        }
      })) + "</a></li>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "sameDeviceOVEnrollmentEnabled") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(22, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 2460
          },
          "end": {
            "line": 1,
            "column": 2778
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "showAnotherDeviceLink") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(24, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 2778
          },
          "end": {
            "line": 1,
            "column": 3117
          }
        }
      })) != null ? stack1 : "") + "</ol></div>";
    },
    "8": function(container, depth0, helpers, partials, data) {
      return " ov-enrollment-enabled";
    },
    "10": function(container, depth0, helpers, partials, data) {
      var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return void 0;
      };
      return '<div class="desktop-instructions ov-info">' + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(alias1, {
        "name": "i18n",
        "hash": {
          "$1": "<span class='semi-strong'>$1</span>",
          "bundle": "login",
          "code": "oie.enroll.okta_verify.setup.customUri.prompt"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 1162
          },
          "end": {
            "line": 1,
            "column": 1279
          }
        }
      })) + '</div><div class="desktop-instructions">' + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "sameDeviceOVEnrollmentEnabled") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(11, data, 0),
        "inverse": container.program(13, data, 0),
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 1319
          },
          "end": {
            "line": 1,
            "column": 1575
          }
        }
      })) != null ? stack1 : "") + "</div>" + ((stack1 = lookupProperty(helpers, "unless").call(alias1, depth0 != null ? lookupProperty(depth0, "sameDeviceOVEnrollmentEnabled") : depth0, {
        "name": "unless",
        "hash": {},
        "fn": container.program(15, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 1581
          },
          "end": {
            "line": 1,
            "column": 1757
          }
        }
      })) != null ? stack1 : "");
    },
    "11": function(container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return void 0;
      };
      return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "$1": "<span>$1</span>",
          "bundle": "login",
          "code": "customUri.required.content.prompt"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 1356
          },
          "end": {
            "line": 1,
            "column": 1441
          }
        }
      }));
    },
    "13": function(container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return void 0;
      };
      return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "$1": "<span class='semi-strong'>$1</span>",
          "bundle": "login",
          "code": "oie.enroll.okta_verify.setup.customUri.noPrompt"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 1449
          },
          "end": {
            "line": 1,
            "column": 1568
          }
        }
      }));
    },
    "15": function(container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return void 0;
      };
      return '<div class="desktop-instructions">' + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.okta_verify.setup.customUri.makeSureHaveOV"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 1656
          },
          "end": {
            "line": 1,
            "column": 1740
          }
        }
      })) + "</div>";
    },
    "17": function(container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return void 0;
      };
      return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.okta_verify.setup.customUri.makeSureHaveOVToContinue"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 1765
          },
          "end": {
            "line": 1,
            "column": 1859
          }
        }
      }));
    },
    "19": function(container, depth0, helpers, partials, data) {
      var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return void 0;
      };
      return ((stack1 = lookupProperty(helpers, "if").call(alias1, (stack1 = depth0 != null ? lookupProperty(depth0, "deviceMap") : depth0) != null ? lookupProperty(stack1, "platformLC") : stack1, {
        "name": "if",
        "hash": {},
        "fn": container.program(20, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 1931
          },
          "end": {
            "line": 1,
            "column": 2168
          }
        }
      })) != null ? stack1 : "") + "<li>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(alias1, {
        "name": "i18n",
        "hash": {
          "$1": "<span class='semi-strong'>$1</span>",
          "bundle": "login",
          "code": "oie.enroll.okta_verify.setup.customUri.setup"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 2172
          },
          "end": {
            "line": 1,
            "column": 2288
          }
        }
      })) + "</li>";
    },
    "20": function(container, depth0, helpers, partials, data) {
      var stack1, alias1 = container.escapeExpression, alias2 = container.lambda, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return void 0;
      };
      return "<li><a aria-label='" + alias1((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "customUri.required.content.download.linkText"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 1978
          },
          "end": {
            "line": 1,
            "column": 2053
          }
        }
      })) + `' href="` + alias1(alias2((stack1 = depth0 != null ? lookupProperty(depth0, "deviceMap") : depth0) != null ? lookupProperty(stack1, "downloadHref") : stack1, depth0)) + '" class="app-store-logo ' + alias1(alias2((stack1 = depth0 != null ? lookupProperty(depth0, "deviceMap") : depth0) != null ? lookupProperty(stack1, "platformLC") : stack1, depth0)) + '-app-store-logo"></a></li>';
    },
    "22": function(container, depth0, helpers, partials, data) {
      var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return void 0;
      };
      return "<li><span>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "customUri.required.content.download.title"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 2507
          },
          "end": {
            "line": 1,
            "column": 2579
          }
        }
      })) + '</span>&nbsp;<a href="' + alias3(container.lambda((stack1 = depth0 != null ? lookupProperty(depth0, "deviceMap") : depth0) != null ? lookupProperty(stack1, "downloadHref") : stack1, depth0)) + '" target="_blank" id="download-ov" class="download-ov-link">' + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "customUri.required.content.download.linkText"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 2687
          },
          "end": {
            "line": 1,
            "column": 2762
          }
        }
      })) + "</a></li>";
    },
    "24": function(container, depth0, helpers, partials, data) {
      var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return void 0;
      };
      return "<li>" + ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, (stack1 = depth0 != null ? lookupProperty(depth0, "deviceMap") : depth0) != null ? lookupProperty(stack1, "isDesktop") : stack1, {
        "name": "if",
        "hash": {},
        "fn": container.program(25, data, 0),
        "inverse": container.program(27, data, 0),
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 2811
          },
          "end": {
            "line": 1,
            "column": 3105
          }
        }
      })) != null ? stack1 : "") + "</li>";
    },
    "25": function(container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return void 0;
      };
      return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "$1": "<a class='orOnMobileLink' href='#'>$1</a>",
          "bundle": "login",
          "code": "oie.enroll.okta_verify.setup.customUri.orOnMobile"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 2838
          },
          "end": {
            "line": 1,
            "column": 2965
          }
        }
      }));
    },
    "27": function(container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return void 0;
      };
      return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "$1": "<a class='orOnMobileLink' href='#'>$1</a>",
          "bundle": "login",
          "code": "oie.enroll.okta_verify.setup.customUri.orMobile"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 2973
          },
          "end": {
            "line": 1,
            "column": 3098
          }
        }
      }));
    },
    "29": function(container, depth0, helpers, partials, data) {
      var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return void 0;
      };
      return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "sameDevice") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(30, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 3136
          },
          "end": {
            "line": 1,
            "column": 4013
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "deviceBootstrap") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(32, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 4013
          },
          "end": {
            "line": 1,
            "column": 4794
          }
        }
      })) != null ? stack1 : "");
    },
    "30": function(container, depth0, helpers, partials, data) {
      var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, alias4 = container.lambda, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return void 0;
      };
      return '<p class="explanation" data-se="subheader">' + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.okta_verify.setup.subtitle "
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 3197
          },
          "end": {
            "line": 1,
            "column": 3266
          }
        }
      })) + '</p><ol class="sameDevice-info ov-info"><li>' + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "arguments": "sameDevice.downloadHref",
          "bundle": "login",
          "code": "enroll.oda.without.account.step1"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 3310
          },
          "end": {
            "line": 1,
            "column": 3411
          }
        }
      })) != null ? stack1 : "") + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.okta_verify.setup.openOv"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 3420
          },
          "end": {
            "line": 1,
            "column": 3486
          }
        }
      })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.okta_verify.setup.signInUrl"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 3495
          },
          "end": {
            "line": 1,
            "column": 3564
          }
        }
      })) + "<br><br/><span class='semi-strong no-translate'>" + alias3(alias4((stack1 = depth0 != null ? lookupProperty(depth0, "sameDevice") : depth0) != null ? lookupProperty(stack1, "orgUrl") : stack1, depth0)) + '</span><a data-clipboard-text="' + alias3(alias4((stack1 = depth0 != null ? lookupProperty(depth0, "sameDevice") : depth0) != null ? lookupProperty(stack1, "orgUrl") : stack1, depth0)) + '" class="button link-button copy-org-clipboard-button">' + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.oda.org.copyLink"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 3740
          },
          "end": {
            "line": 1,
            "column": 3794
          }
        }
      })) + "</a></li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.okta_verify.setup.skipAuth.followInstruction"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 3807
          },
          "end": {
            "line": 1,
            "column": 3893
          }
        }
      })) + '</li></ol><p class="closing">' + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.okta_verify.setup.skipAuth.canBeClosed"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 3922
          },
          "end": {
            "line": 1,
            "column": 4002
          }
        }
      })) + "</p>";
    },
    "32": function(container, depth0, helpers, partials, data) {
      var alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return void 0;
      };
      return '<p class="explanation" data-se="subheader">' + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.okta_verify.setup.skipAuth.subtitle"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 4079
          },
          "end": {
            "line": 1,
            "column": 4156
          }
        }
      })) + '</p><ol class="deviceBootstrap-info ov-info"><li>' + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "$1": "<span class='semi-strong'>$1</span>",
          "arguments": "enrolledDeviceName",
          "bundle": "login",
          "code": "oie.enroll.okta_verify.setup.skipAuth.openOv.suchAs"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 4205
          },
          "end": {
            "line": 1,
            "column": 4359
          }
        }
      })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.okta_verify.setup.skipAuth.selectAccount"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 4368
          },
          "end": {
            "line": 1,
            "column": 4450
          }
        }
      })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "$1": "<span class='semi-strong'>$1</span>",
          "bundle": "login",
          "code": "oie.enroll.okta_verify.setup.skipAuth.addAccount"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 4459
          },
          "end": {
            "line": 1,
            "column": 4579
          }
        }
      })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.okta_verify.setup.skipAuth.followInstruction"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 4588
          },
          "end": {
            "line": 1,
            "column": 4674
          }
        }
      })) + '</li></ol><p class="closing">' + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.okta_verify.setup.skipAuth.canBeClosed"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 4703
          },
          "end": {
            "line": 1,
            "column": 4783
          }
        }
      })) + "</p>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function(container, depth0, helpers, partials, data) {
      var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return void 0;
      };
      return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "href") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 452
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "email") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(3, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 452
          },
          "end": {
            "line": 1,
            "column": 685
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "phoneNumber") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(5, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 685
          },
          "end": {
            "line": 1,
            "column": 926
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, (stack1 = depth0 != null ? lookupProperty(depth0, "deviceMap") : depth0) != null ? lookupProperty(stack1, "setupOVUrl") : stack1, {
        "name": "if",
        "hash": {},
        "fn": container.program(7, data, 0),
        "inverse": container.program(29, data, 0),
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 926
          },
          "end": {
            "line": 1,
            "column": 4801
          }
        }
      })) != null ? stack1 : "");
    },
    "useData": true
  }),
  /* eslint complexity: [2, 20] */
  getTemplateData: function() {
    var _contextualData$qrcod;
    const contextualData = this.options.appState.get("currentAuthenticator").contextualData;
    let enrolledDeviceName = "";
    let deviceMap = getDeviceMap(this.options.appState);
    let showAnotherDeviceLink = false;
    if (contextualData) {
      if (contextualData !== null && contextualData !== void 0 && contextualData.devicebootstrap && contextualData !== null && contextualData !== void 0 && contextualData.devicebootstrap.enrolledDevices) {
        const enrolledDevices = contextualData === null || contextualData === void 0 ? void 0 : contextualData.devicebootstrap.enrolledDevices;
        enrolledDeviceName = Array.isArray(enrolledDevices) && !oktaUnderscore.isEmpty(enrolledDevices) ? enrolledDevices[0] : enrolledDevices;
      }
    }
    if (deviceMap.securityLevel && deviceMap.securityLevel === "ANY") {
      showAnotherDeviceLink = true;
    }
    const sameDeviceOVEnrollmentEnabled = this.options.settings.get("features.sameDeviceOVEnrollmentEnabled");
    return {
      href: (_contextualData$qrcod = contextualData.qrcode) === null || _contextualData$qrcod === void 0 ? void 0 : _contextualData$qrcod.href,
      email: oktaUnderscore.escape(contextualData === null || contextualData === void 0 ? void 0 : contextualData.email),
      phoneNumber: oktaUnderscore.escape(contextualData === null || contextualData === void 0 ? void 0 : contextualData.phoneNumber),
      sameDevice: contextualData === null || contextualData === void 0 ? void 0 : contextualData.samedevice,
      deviceBootstrap: contextualData === null || contextualData === void 0 ? void 0 : contextualData.devicebootstrap,
      enrolledDeviceName,
      deviceMap,
      showAnotherDeviceLink,
      sameDeviceOVEnrollmentEnabled
    };
  },
  postRender: function() {
    const appState = this.options && this.options.appState;
    const model = this.model;
    this.$(".orOnMobileLink").click(function() {
      var _qrChannelField$optio;
      if (!appState || !model) {
        return;
      }
      const qrChannel = "qrcode";
      const remediations = appState.get("remediations");
      const selectEnrollmentChannelRemediation = remediations.find((remediation) => {
        return remediation.name === FORMS.SELECT_ENROLLMENT_CHANNEL;
      });
      if (!selectEnrollmentChannelRemediation) {
        return;
      }
      const idField = oktaUnderscore.find(selectEnrollmentChannelRemediation.uiSchema, (schema) => schema.name === "authenticator.id");
      if (!idField) {
        return;
      }
      const qrChannelField = oktaUnderscore.find(selectEnrollmentChannelRemediation.uiSchema, (schema) => schema.name === "authenticator.channel");
      if (!qrChannelField) {
        return;
      }
      qrChannelField.options = oktaUnderscore.filter(qrChannelField === null || qrChannelField === void 0 ? void 0 : qrChannelField.options, (option) => option.value === qrChannel);
      qrChannelField.value = ((_qrChannelField$optio = qrChannelField.options[0]) === null || _qrChannelField$optio === void 0 ? void 0 : _qrChannelField$optio.value) || qrChannel;
      qrChannelField.sublabel = null;
      model.set("authenticator.channel", qrChannelField.value);
      model.set("authenticator.id", idField.value);
      model.set("formName", selectEnrollmentChannelRemediation.name);
      appState.trigger("saveForm", model);
    });
    Clipboard.attach(".copy-org-clipboard-button").done(() => {
      let notification = new Notification({
        message: loc("enroll.oda.org.copyLink.success", "login"),
        level: "success"
      });
      this.el.prepend(notification.render().el);
      return false;
    });
  }
});
function getDeviceMap(appState) {
  var _contextualData$samed, _contextualData$devic;
  if (!appState) {
    return null;
  }
  const contextualData = appState.get("currentAuthenticator").contextualData;
  let deviceMap = {};
  if ((_contextualData$samed = contextualData.samedevice) !== null && _contextualData$samed !== void 0 && _contextualData$samed.setupOVUrl) {
    deviceMap = contextualData.samedevice;
  } else if ((_contextualData$devic = contextualData.devicebootstrap) !== null && _contextualData$devic !== void 0 && _contextualData$devic.setupOVUrl) {
    deviceMap = contextualData.devicebootstrap;
  }
  if (deviceMap.platform) {
    deviceMap.platformLC = deviceMap.platform.toLowerCase();
    deviceMap.isDesktop = !(deviceMap.platformLC === "ios" || deviceMap.platformLC === "android");
  }
  return deviceMap;
}
export { EnrollChannelPollDescriptionView as default };
